import { Dialog } from "@headlessui/react"
import { FormBox, ModalFoterBox } from "../../components/box/Box"
import Button from "../../components/button/Button"
import { Modal, ModalProp } from "../../components/modal/Modal"
import { Consent, consentSchema } from "../../model/Consent"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForm } from "react-hook-form"
import FormController from "../../components/fields/FormController"
import { useEffect, useMemo } from "react"
import { RadioButton, RadioButtonItem } from "../../components/radiobutton/RadioButton"
import { useInput } from "../../hooks/useInput"

export type TermsOfUseManagementEditModalProp = {
  consent?: Consent;
  onSubmit: (data: Consent) => Promise<void>;
}

export const TermsOfUseManagementEditModal = ({
  children,
  open,
  toggle,
  closeOnClickOutside,
  updateFlg,
  consent,
  onSubmit,
}: ModalProp & TermsOfUseManagementEditModalProp) => {

  const { control, handleSubmit, setValue, reset } =
    useForm<Consent>({
      resolver: yupResolver(consentSchema),
      defaultValues: consent,
    });

  const appTypeItem: RadioButtonItem[] = [
    {
      id: 'mobileSelect',
      title: 'ジョイン'
    },
    {
      id: 'staffSelect',
      title: 'イベントサポート'
    }
  ];
  const appTypeValue = useInput('mobileSelect');

  const typeItem: RadioButtonItem[] = [
    {
      id: 'termsOfServicesSelect',
      title: '利用規約'
    },
    {
      id: 'privacyPolicySelect',
      title: 'プライバシーポリシー'
    }
  ];
  const typeValue = useInput('termsOfServicesSelect');

  useEffect(() => {
    if (consent) {
      setValue('version', consent.version ?? '');
      setValue('title', consent.title ?? '');
      setValue('text', consent.text ?? '');
      setValue('appType', consent.appType ?? 'mobile');
      setValue('type', consent.type ?? 'termsOfServices');
      appTypeValue.setValue(`${consent.appType}Select`);
      typeValue.setValue(`${consent.type}Select`);
    }
  }, [consent, setValue]);

  useEffect(() => {
    const value = appTypeValue.value === 'mobileSelect' ? 'mobile' : 'staff';
    setValue('appType', value);
  },[appTypeValue.value, setValue]);

  useEffect(() => {
    const value = typeValue.value === 'termsOfServicesSelect' ? 'termsOfServices' : 'privacyPolicy';
    setValue('type', value);
  },[setValue, typeValue.value]);

  useEffect(() => {
    if(!open){
      reset();
      appTypeValue.setValue('mobileSelect');
      typeValue.setValue('termsOfServicesSelect');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[open, reset]);

  return (
    <Modal
      open={open}
      toggle={toggle}
      closeOnClickOutside={closeOnClickOutside}
    >
      <Dialog.Panel className=" relative transform overflow-hidden rounded-lg bg-white  text-left shadow-xl transition-all">
        <form
          onSubmit={handleSubmit(onSubmit)}
          noValidate
        >
          <div className="p-4">
            <h3 className="text-lg font-medium leading-6 text-gray-800">
              利用規約・プライバシーポリシー規約
            </h3>
          </div>
          <div className="overflow-y-auto px-8 text-left pb-8 h-[calc(100vh_-_10rem)]">
            <FormBox>
              <RadioButton
                vertical
                label={'適応範囲'}
                name={"appType"}
                children={undefined}
                radioButtonItem={appTypeItem}
                value={appTypeValue}
                className={"whitespace-nowrap sm:space-x-4"}
              />
              <RadioButton
                vertical
                label={'規約形態'}
                children={undefined}
                name={"type"}
                radioButtonItem={typeItem}
                value={typeValue}
                className={"whitespace-nowrap sm:space-x-4"}
              />
            </FormBox>
            <FormBox>
              <FormController
                control={control}
                name={"version"}
                label={"バージョン"}
                type={"text"}
                required
              />
              <FormController
                control={control}
                name={"title"}
                label={"タイトル"}
                type={"text"}
                required
              />
            </FormBox>
            <FormController
              control={control}
              name={"text"}
              label={"本文"}
              type={"textarea"}
              className={"h-[calc(100vh_-_22rem)]"}
              required
            />
          </div>
          <ModalFoterBox>
            <Button
              className="mx-2 mt-1 w-[132px]"
              outline
              onClick={toggle}
              children={'キャンセル'}
            />
            <Button
              className="mt-1 w-[132px]"
              submit
              children={'登録'}
            />
          </ModalFoterBox>
        </form>
      </Dialog.Panel>
    </Modal>
  )
}